export default __webpack_public_path__ + "3a6bc12758a5f51a3df1a20ecef2f1af.wav";